// git hash 3c5c1718272738f3e044029c228d02e6ce019542
export default {
  'editionSettings': {
    'key': 'espn-en',
    'site': 'espn',
    'language': 'en',
    'country': 'us',
    'domain': 'www.espn.com',
    'editionSiteId': '1',
    'https': false
  },
  'navId': '11929946',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'US'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'US/Eastern',
    'timeZoneBucket': 'America/New_York',
    'defaultFormat': 'MMM d, yyyy',
    'timeZoneString': 'ET',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'fahrenheit',
    'symbol': '&deg; F'
  },
  'outbrain': {
    'enabled': true,
    'template': 'espn',
    'desktop': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'AR_12'
    },
    'mobile': {
      'compliantId': 'AR_49',
      'nonCompliantId': 'MB_5'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'recap': {
      'desktop': {
        'compliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_9'
      }
    },
    'report': {
      'desktop': {
        'compliantId': 'AR_30',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_9',
        'nonCompliantId': 'MB_9'
      }
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'MB_43'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'AR_48'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'partnerAd': false,
    'dev-config': 12129261,
    'qa-config': 12129262,
    'prod-config': 12129264
  },
  'partnerModules': {
    'global': true,
    'nba': true,
    'womenbb': true,
    'golf': true,
    'endurance': true,
    'horse': true,
    'nascar': true
  },
  'sportBranding': [ {
    'sport': 'cricket',
    'image': 'logo-uk-cricinfo',
    'url': 'http://www.espncricinfo.com'
  }, {
    'sport': 'soccer',
    'image': 'logo-uk-fc',
    'url': 'http://www.espnfc.us'
  }, {
    'sport': 'rugby',
    'image': 'logo-uk-scrum',
    'url': null
  }, {
    'sport': 'ncaaw',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'ncw',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'wnba',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'womenbb',
    'image': 'ESPNcom-powerby-espnw',
    'url': 'http://espnw.com'
  } ],
  'siteLogo': {
    'class': '',
    'featurePhone': {
      'name': 'espn-logo',
      'width': 45,
      'height': 11
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for NFL, MLB, NBA, College Football, NCAA Basketball and more.',
    'defaultMetaImage': 'espn_red.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com',
        'locale': 'en_US'
      }
    }
  },
  'shop': {
    'enabled': true
  },
  'sportReplacements': {},
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      'toEdition': {
        '/horse/': '/horse-racing/',
        '/nascar/': '/racing/nascar/',
        '/ncaa/': '/college-sports/',
        '/ncb/': '/mens-college-basketball/',
        '/ncf/': '/college-football/',
        '/oly/': '/olympics/',
        '/rpm/': '/racing/',
        '/womenbb/': '/womens-basketball/',
        '/flb/': '/fantasy/baseball/',
        '/fba/': '/fantasy/basketball/',
        '/ffl/': '/fantasy/football/',
        '/fhl/': '/fantasy/hockey/'
      },
      'toEnglish': {
        '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
        '/oly/summer/cycling/': '/oly/summer/cycling/',
        '/racing/nascar/': '/nascar/',
        '/racing/': '/rpm/',
        '/college-football/': '/ncf/',
        '/college-football/rumors': '/college-football/rumors',
        '/mens-college-basketball/': '/ncb/',
        '/mens-college-basketball/rumors': '/mens-college-basketball/rumors',
        '/womens-college-basketball/': '/ncw/',
        '/womens-basketball/': '/womenbb/',
        '/olympics/': '/oly/',
        '/cycling/': '/oly/',
        '/figure-skating/': '/oly/',
        '/college-sports/': '/ncaa/',
        '/gymnastics/': '/oly/',
        '/skiing/': '/oly/',
        '/horse-racing/': '/horse/',
        '/sports/womenbb/': '/womenbb/',
        '/sports/horse/': '/horse/',
        '/sports/endurance/': '/endurance/',
        '/losangeles/': '/los-angeles/',
        '/newyork/': '/new-york/',
        '/espn/onenacion/': '/onenacion/',
        '/fantasy/baseball/': '/flb/',
        '/fantasy/basketball/': '/fba/',
        '/fantasy/football/': '/ffl/',
        '/fantasy/hockey/': '/fhl/'
      }
    },
    'pathSegments': {},
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': true,
    'game': {
      'enabled': true
    }
  },
  'ticketProvider': 'stubHub',
  'showFavorites': true,
  'showInsider': true,
  'showWatch': true,
  'showCategory': true,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': false,
  'showCricInfoContent': false,
  'cookieConsent': false,
  'scDeepLinking': true,
  'allowShortUrl': true,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': true,
  'hasTickets': true,
  'searchUrl': 'http://search.espn.com/',
  'gameSettings': {
    'topEventsId': 4379198,
    'promotedSoccerLeaguesCeId': 12032789,
    'showBroadcast': true
  },
  'fallback': {
    'football': 'espnuk-en-soccer-index',
    'cricket': 'espn-en-cricket-index'
  },
  'editionAlert': {
    'enabled': false,
    'text': ''
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'TopStoryPackage',
        'HeadlineNews',
        'BlogEntry'
      ]
    }
  },
  'tier2NavIds': {
    'boston': 12375278,
    'chicago': 12505826,
    'cleveland': 13977091,
    'dallas': 12505828,
    'los-angeles': 12505831,
    'milwaukee': 13977360,
    'new-york': 12505854,
    'fantasy/basketball': 12405600,
    'fantasy/football': 12405632,
    'fantasy/baseball': 12405631,
    'fantasy/hockey': 12405634,
    'fantasy': 13609307,
    'ncfrecruiting': 11588758,
    'ncbrecruiting': 11588880,
    'esports': 13663224,
    'onenacion': 13309315,
    'jayski': 16584380,
    'ncf/weekday-walkthrough': 17165710,
    'wwe': 17101058,
    'sportsnation': 12544987,
    'nba/stephen-curry': 14950765,
    'league': {
      'soccer': 13794648,
      'ncf': 13886385,
      'college-football': 13886385,
      'cricket': 15609108
    },
    'watch': 15726903,
    'espn/caponecup': 17140605
  },
  'tier3NavIds': {
    'clubhouse': {
      'nba': 12293424,
      'mlb': 12343023,
      'mens-college-basketball': 13884705,
      'womens-college-basketball': 13930164,
      'soccer': 12294454,
      'nfl': 12509708,
      'college-football': 13345157,
      'cricket': 15368856
    },
    'doubletruck': 14830831
  },
  'indexAutoStart': false,
  'useMongo': true,
  'activeSite': true,
  'countries': [ {
    'name': 'United States',
    'country-code': 'us',
    'showHreflang': true
  } ]
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/unitedstates.js